var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['stylable-textarea', {'center': _vm.alignCenter}, {'pointer': _vm.pointer}],on:{"click":_vm.onClick}},[_c('div',[(_vm.valueLength)?[_c('div',{domProps:{"innerHTML":_vm._s(_vm.inactiveValue)}})]:_c('span',{staticClass:"placeholderText"},[_vm._v(_vm._s(_vm.placeholder))])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }